import type { ReactElement, ReactNode } from 'react';

import type { ListingViewApplyAts } from '#/modules/listing/components/ListingView/Apply/ListingViewApplyAts';
import type { ListingViewApplyExternal } from '#/modules/listing/components/ListingView/Apply/ListingViewApplyExternal';
import { ListingViewSection } from '#/modules/listing/components/ListingView/Section/ListingViewSection';

type Props = {
  title: string;
  children:
    | ReactElement<typeof ListingViewApplyAts>
    | ReactElement<typeof ListingViewApplyExternal>
    | ReactNode;
};

export function ListingViewApplySection({ title, children }: Props) {
  return (
    <ListingViewSection id="apply" title={title}>
      {children}
    </ListingViewSection>
  );
}
